import * as React from 'react';
import { styled } from '@mui/system';
import { TextareaAutosize, TextareaAutosizeProps } from '@mui/material';

const grey = {
  50: '#F3F6F9',
  100: '#E5EAF2',
  200: '#DAE2ED',
  300: '#C7D0DD',
  400: '#B0B8C4',
  500: '#9DA8B7',
  600: '#6B7A90',
  700: '#434D5B',
  800: '#303740',
  900: '#1C2025',
};

const TextareaAutosizeStyled = styled(TextareaAutosize)(
  () => `
  width: 360px;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: ${grey[900]};
  background: #fff;
  border: 1px solid ${grey[200]};
 

  // firefox
  &:focus-visible {
    outline: 0;
  }
`
);

export const Textarea = (props: TextareaAutosizeProps) => {
  return <TextareaAutosizeStyled {...props} />;
};
